import {
	parseStyle,
	decodeStyle,
	mobile,
	tablet,
	isHidden,
} from "../../../juntion";
// import { getContent } from "../../../../dynamicdata/parser";
// import { getContent } from "../../../../dynamicdata/parser";
import { getContent, checkConditions } from "../../../junctionAbs";


const isString = (value) => {
	return typeof value === "string" || value instanceof String;
};

function Text({ id, db, dydb, gs, device }) {
	const data = db[id];

	const ps = parseStyle(data, gs, data.cstate);

	if (isHidden(ps.classes, device)) {
		return null;
	}

	const tabletStyle = tablet(device) ? ps.tablet : {};
	const mobileStyle = mobile(device) ? ps.mobile : {};

	let input = ps.input;
	input = { ...input, ...(tablet(device) && ps.itablet) };
	input = { ...input, ...(mobile(device) && ps.imobile) };

	let content = input.content;
	if (!isString(content)) {
		content = getContent(dydb, content);
	}

	const decodedStyle = {
		...decodeStyle(ps.fixStyle, gs),
		...decodeStyle(ps.style, gs),
		...(tablet(device) && decodeStyle(tabletStyle, gs)),
		...(mobile(device) && decodeStyle(mobileStyle, gs)),
	};

	//for transition period only
	// let fontSize = data.input?.fontSize || decodedStyle?.fontSize || 16;
	// let lineHeight = data.input?.lineHeight || decodedStyle?.lineHeight || 1.6;
	let fontSize = ps.input?.fontSize || decodedStyle?.fontSize || 16;
	let lineHeight = ps.input?.lineHeight || decodedStyle?.lineHeight || 1.6;

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
			}}
		>
			<div
				style={{
					columnWidth: "auto",
					columnCount: input.columnCount,
					// "&:hover": decodeStyle(ps.hover, gs),
					textAlign: input.textAlign,
					...decodedStyle,
					fontSize: fontSize,
					// "p::first-letter": {
					//     fontSize: "200%",
					// },
				}}
			>
				<p
					style={{
						// lineHeight: ps.style.lineHeight,
						// fontFamily: ps.style.fontFamily,
						// lineHeight: decodedStyle.lineHeight,
						lineHeight: lineHeight,
						fontFamily: decodedStyle.fontFamily,
						outline: "none",
						background: "transparent",
						// whiteSpace: "pre-wrap",
						//maxLines
						maxWidth: "100%",
						display: "-webkit-box",
						WebkitBoxOrient: "vertical",
						WebkitLineClamp: input.maxLines?.value,
						overflow: "hidden",
						textOverflow: "ellipsis",
					}}
					dangerouslySetInnerHTML={{ __html: content }}
				>
					{/* {content} */}
				</p>
			</div>
		</div>
	);
}

export default Text;
